<template>
  <div>
    <wc-data-box
      title='Tasks assigned to me'
      :showAdd='false'
      @add='createTask(true)'
    >
      <v-data-table
        :items='assignedTasks'
        :headers='headers'
        dense
        @click:row='openTask'
        no-data-text='You have no tasks assigned to you' 
      >
        <template v-slot:item.status='{ item }'>
          <v-icon :color='getStatus(item).color'>
            {{ getStatus(item).icon }}
          </v-icon>
        </template>
        <template v-slot:item.priority='{ item }'>
          <span class='caption mr-1'>{{ getPriority(item).text }}</span>
        </template>
        <template v-slot:item.description='{ item }'>
          {{ item.read ? item.description : "You have a new Task! (click to open)" }}
        </template>
        <template v-slot:item.date_due='{ item }'>
          <span v-if='item.date_due' :class='calcDueColor(item)'>{{ item.date_due | shortDateWithDay }}
            <span class='caption' v-if='item.time_due'>{{ item.time_due | time }}</span>
          </span>
          <span v-else class="grey--text text--lighten-2 font-italic">not set</span>
        </template>
        <template v-slot:item.task_manager='{ item }'>
          {{ item.task_manager_obj ? item.task_manager_obj.name_display : item.task_manager }}
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-data-box
      v-if='managedTasks.length'
      title='Tasks to manage'
      class='mt-10'
      :showAdd='false'
      @add='createTask'
    >
      <v-data-table
        :items='managedTasks'
        :headers='headers2'
        dense
        @click:row='openTask'
        no-data-text='You have no tasks to manage'
      >
        <template v-slot:item.description='{ item }'>
          <v-tooltip top>
            <template v-slot:activator='{ on }'>
              <v-icon v-if='item.event' v-on='on'>mdi-calendar-cursor</v-icon>
            </template>
            <span class='caption'>Event Task</span>
          </v-tooltip>
          {{ item.description }}
        </template>
        <template v-slot:item.status='{ item }'>
          <v-icon :color='getStatus(item).color'>
            {{ getStatus(item).icon }}
          </v-icon>
        </template>
        <template v-slot:item.priority='{ item }'>
          <span class='caption mr-1'>{{ getPriority(item).text }}</span>
        </template>
        <template v-slot:item.date_due='{ item }'>
          <span v-if='item.date_due' :class='calcDueColor(item)'>{{ item.date_due | shortDateWithDay }}
            <span class='caption' v-if='item.time_due'>{{ item.time_due | time }}</span>
          </span>
          <span v-else class="grey--text text--lighten-2 font-italic">not set</span>
        </template>
        <template v-slot:item.assigned_to='{ item }'>
          {{ item.assigned_to_obj ? item.assigned_to_obj.name_display : item.assigned_to }}
        </template>
      </v-data-table>
    </wc-data-box>

    <task-dialog
      v-if='taskCopy'
      :showDialog='showDialog'
      :taskCopy.sync="taskCopy"
      :profiles='profiles'
      @save='save'
      @cancel='cancel'
      @deleteTask='deleteTask'
    ></task-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import formRules from '@/mixins/formRules'
import TaskDialog from '@/modules/tasks/components/TaskDialog'

export default {
  name: 'tasks-table',
  mixins: [formRules],
  props: {
    assignedTasks: {
      required: true,
      type: Array
    },
    managedTasks: {
      required: true,
      type: Array
    },
    profiles: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    isLoading: false,
    showDialog: false,
    headers: [
      { text: '', value: 'status', width: "56", sortable: false },
      { text: 'Priority', value: 'priority', width: "95" },
      { text: 'Description', value: 'description' },
      { text: 'Due Date', value: 'date_due', width: "250" },
      { text: 'Task Manager', value: 'task_manager', width: "200" },
    ],
    headers2: [
      { text: '', value: 'status', width: "56", sortable: false },
      { text: 'Priority', value: 'priority', width: "95" },
      { text: 'Description', value: 'description' },
      { text: 'Due Date', value: 'date_due', width: "250" },
      { text: 'Assigned to', value: 'assigned_to', width: "200" },
    ],
    resetTask: {},
    taskCopy: null
  }),
  methods: {
    getPriority(item) {
      let tmp = this.$store.state.misc.globalOptions.taskPriorities.find(p => p.value === item.priority)
      if (tmp) {
        return tmp
      }
      return { text: "", value: null }
    },
    getStatus (item) {
      if (!item.id) {
        return { icon: this.$icons.task_new.icon, color: this.$icons.task_new.color, text: this.$icons.task_new.title }
      } else if (!item.read) {
        return { icon: this.$icons.task_unread.icon, color: this.$icons.task_unread.color, text: this.$icons.task_unread.title }
      } else if (item.is_complete) {
        return { icon: this.$icons.task_complete.icon, color: this.$icons.task_complete.color, text: this.$icons.task_complete.title }
      } else if (item.is_attempted) {
        return { icon: this.$icons.task_attempted.icon, color: this.$icons.task_attempted.color, text: this.$icons.task_attempted.title }
      } else if (item.in_progress) {
        return { icon: this.$icons.task_progress.icon, color: this.$icons.task_progress.color, text: this.$icons.task_progress.title }
      } else {
        return { icon: this.$icons.task_read.icon, color: this.$icons.task_read.color, text: this.$icons.task_read.title }
      }
    },
    calcDueColor(item) {
      if ( !item.is_complete && item.time_due && moment(item.date_due + 'T' + item.time_due).isBefore(this.now) ) {
        return "error--text"
      } else if ( !item.is_complete && moment(item.date_due).isSame(this.now, 'day') ) {
        return "warning--text"
      } else if ( !item.is_complete && moment(item.date_due).isBefore(this.now, 'day') ) {
        return "error--text"
      } else {
        return ""
      }
    },
    createTask(forMe = null) {
      this.taskCopy = this.resetTask
      // this.taskProgress = null
      this.taskCopy.created_by = this.$store.state.auth.profile.id
      this.taskCopy.task_manager = this.$store.state.auth.profile.id
      this.taskCopy.date_created = moment().format('YYYY-MM-DDTHH:mm:ss')
      this.taskCopy.assigned_to = forMe ? this.$store.state.auth.profile.id : null
      this.showDialog = true
    },
    openTask(task) {
      this.taskCopy = _.cloneDeep(task)
      if (!task.read && task.assigned_to == this.$store.state.auth.profile.id) {
        task.read = true
        this.taskCopy.read = true
        this.$emit('update', task)
      }
      this.$nextTick (()=>{
        this.showDialog = true
      })
    },
    save(){
      console.log(this.taskCopy)
      if (this.taskCopy.id) {
        this.$emit('update', this.taskCopy)
      } else {
        this.$emit('create', this.taskCopy)
      }
      this.showDialog = false
    },
    cancel () {
      this.showDialog = false
    },
    deleteTask () {
      this.$emit('deleteTask', this.taskCopy)
      this.showDialog = false
    }
  },
  components: {
    'task-dialog': TaskDialog
  }
}
</script>

<style scoped>

/* want to get the readonly text darker... but, can't ... yet - MJ */

/*.theme--light.v-select .v-select__selection--disabled {
  color:  rgba(0, 0, 0, 0.87) !important;
}*/

</style>
